import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IReview } from '../types/Review';
import { orderAPI } from '../api/orderAPI';

export const useReviewOrder = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async (body: IReview) => await orderAPI.review(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['order'] });
    },
  });
  return {
    reviewOrder: mutateAsync,
    isPending,
  };
};
